@use "./../../../styles/sdx.scss";
:host {
  display: block;
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
  position: relative;
  z-index: 1;
}

.card-shell {
  & {
    border: none;
    border-radius: var(--sdx-border-radius-xlarge);
    width: 100%;
    height: 100%;
    backface-visibility: hidden;
    background-size: cover;
    background-repeat: no-repeat;
    box-sizing: border-box;
    overflow: hidden;
  }

  &--shadow {
    box-shadow: var(--sdx-box-shadow-default);
  }
  display: flex;

  &--top {
    flex-flow: column nowrap;
  }

  &--bottom {
    flex-flow: column nowrap;
  }

  &--left {
    flex-flow: row nowrap;
  }
}

.card-content {
  width: 100%;
  box-sizing: border-box;

  &--top {
    margin-top: auto;
    padding-top: var(--sdx-spacing-4);
  }

  &--bottom {
    margin-bottom: auto;
    padding-bottom: var(--sdx-spacing-4);
  }

  &--right {
    margin-left: auto;
  }
}

.card-image {
  display: none;
}
.card-backdrop {
  & {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    pointer-events: none;
    border: none;
    border-radius: var(--sdx-border-radius-xlarge);
    overflow: hidden;
    z-index: -1;
  }

  &__empty,
  &__figure {
    background: var(--sdx-color-sc-white);
  }

  &__img,
  &__video,
  &__figure {
    width: 100%;
    height: 100%;
    object-fit: cover;
    margin: 0;
    padding: 0;
  }
}
